import { cn } from '@/shared/lib/utils/classnames';
import type { TableBlock as TableBlockType } from '@/shared/types/blocks';

type TableBlockProps = Omit<TableBlockType, 'type' | 'id'>;

/**
 * TableBlock - 테이블
 *
 * 정형 데이터를 테이블 형식으로 표시합니다.
 */
export function TableBlock({ headers, rows, alignment }: TableBlockProps) {
  const getAlignment = (index: number) => {
    const align = alignment?.[index] || 'left';
    return {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    }[align];
  };

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b border-border">
            {headers.map((header) => (
              <th
                key={header}
                className={cn(
                  'px-4 py-3 text-sm font-bold text-foreground bg-muted',
                  getAlignment(headers.indexOf(header)),
                )}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => {
            const rowKey = row.join('-');
            return (
              <tr
                key={rowKey}
                className={cn(
                  'border-b border-border last:border-0',
                  rowIndex % 2 === 0 ? 'bg-white' : 'bg-muted/30',
                )}
              >
                {row.map((cell, cellIndex) => {
                  const cellKey = `${rowKey}-${cell}-${cellIndex}`;
                  return (
                    <td
                      key={cellKey}
                      className={cn('px-4 py-3 text-sm text-foreground', getAlignment(cellIndex))}
                    >
                      {cell}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
